module.exports = __webpack_public_path__ + "img/firewood.74adead9.svg";